/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { createIndexNode } from '../../factoriesAny.js';
export var IndexNodeDependencies = {
  NodeDependencies,
  sizeDependencies,
  createIndexNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIndexNode.generated.js
// module id = 184
// module chunks = 2